module.exports = __webpack_public_path__ + "assets/9e64434a232f26e99c9ef148ef122efd.mp3";